<template>
  <div>

    <!--
    드래그 & 드롭 (방법1)
    
      emit
      1. return : 파일을 설정한 경로에 저장 후 첨부파일 테이블의 시퀀스 번호를 emit.
      2. deleteFile : 삭제할 파일 시퀀스 번호 emit
    -->
    <i class="pi pi-info-circle" style="font-size: 0.9rem;"> 개별 파일당 등록 가능한 최대 용량은 10MB입니다.</i>
    <DragDrop v-if="props.canUpdate" :uppy="uppy" :props="option" />
    
    <div class="dragdrop-list-wrap mt-3 py-3 px-4"  v-if="state.fileParams.fileListVo.length > 0">
    <span class="fw-semibold">업로드 파일 목록</span>
      <div class="border-bottom d-flex justify-content-between p-2 mt-2" v-for="(file,index) in state.fileParams.fileListVo">
        <span @click="downFile(file)" style="cursor: pointer;">
          {{ (index+1) }}. {{ file.file_org_nm }}
        </span>
        <ElButton v-if="props.canUpdate" type="fileDel" @buttonClick="deleteFile(index)" ></ElButton>
      </div>
    </div>
  </div>

    <!--대시보드 (방법 2) 기능 사용시 주석 해제-->
    <!-- <Dashboard 
      :uppy="dashUppy" 
      :plugins="['Webcam']" 
    /> -->

</template>

<script setup>
import {reactive,computed} from 'vue'

//대시보드 기능 사용시 주석 해제
// import Webcam from '@uppy/webcam';
// import '@uppy/dashboard/dist/style.css';
// import '@uppy/webcam/dist/style.css';


import { DragDrop } from "@uppy/vue";
import Uppy from '@uppy/core'
import Tus from "@uppy/tus";

import "@uppy/core/dist/style.css";
import "@uppy/drag-drop/dist/style.css";
import 'primeicons/primeicons.css'
import { useUserStore } from '@/store/user';
const userStore = useUserStore()

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { fileUpload,tempUpload,fileDownload } from '@/api/file';

const props = defineProps({
    canUpdate : {
      type : Boolean,
      default : true
    },
})

//실제 파일 저장 emit 함수
const emits = defineEmits(['return','deleteData'])


// uppy 파일 업로드 box 내용
const option = {
    note: "파일 업로드",
    locale: {
        strings: {
            // 속성에는 문자열과 찾아보기
            dropHereOr: "마우스로 끌어서 파일을 첨부하세요.",
        },
    },
};

const state = reactive({
  tmpFileList : [],
  fileParams : {
    up_path : 'testPath',
    fileListVo  : []
  }
})



// {
//   업로드 가능한 파일 설정
//   restrictions : {
//     allowedFileTypes : ['image/*'],
//   },
// }

const uppy = computed(() => 
  new Uppy().use(Tus,{
    //대용량 파일 업로드
    //경로
    //파일 업로드 가능 사이즈 
    chunkSize : 1024 * 1024 * 10,
    headers:{
      'EZTOBIZ-AUTH-TOKEN' : userStore.getToken
    },
  }).on('files-added' , (files) => {
    if(files.length > 0){
      if(files[0].size > 10000000){
        alert('파일의 크기가 너무 큽니다.')
        return;
      }
      for(var file of files){
        const form = new FormData()
        form.append('file',file.data)
        tempUpload(form).then((res)=>{
          if(res.rtn){
            state.tmpFileList.push(res.rtn)
            state.fileParams.fileListVo.push(res.rtn)
          }
        }).catch((e)=>{
          alert(`${file.data.name} 파일첨부를 실패했습니다.`)
          console.log('error => ',e)
        })
      }
      
    }
    uppy.value.cancelAll("")

  })
)


// 대시보드 파일업로드
// const dashUppy = computed(() => 
//   new Uppy().use(Webcam,{
//     showVideoSourceDropdown: true,
//     showRecordingLength: true
//   }).on('file-added', (file) => {
//     let params = {
//       file : file.data
//     }
//     api.callPutFile('ref_data',params).then((res)=>{
//       // state.tmpFileList.push(res)
//     })
//   })
// )




//임시 파일 -> 실제 저장 함수
const uploadFile = async (path) =>{

  let params = state.fileParams
  
  if(path){
    params.up_path = path
  }else{
    params.up_path = ''
  }

  try {
    setIsLoading(true)
    const res = await fileUpload(params)
    if(res.rtn && res.rtn.length > 0){
      let fileList = [...res.rtn]
      state.tmpFileList = []
      emits('return',fileList)
    }else{
      alert('파일저장에 실패했습니다.')
    }
    
  } catch (err) {
    console.error('upload Error => ', err)
  } finally {
    setIsLoading(false)
  }

}

const deleteFile = (idx) => {
  if(confirm('정말 삭제하시겠습니까?')){
    emits('deleteData',state.fileParams.fileListVo[idx])
    state.tmpFileList.splice(idx,1)
    state.fileParams.fileListVo.splice(idx,1)
  }
 


}


async function downFile(file){
  try{
    setIsLoading(true)
    const response = await fileDownload(file.file_seq)

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", file.file_org_nm);
    link.click();
    link.remove();
  }catch(e){
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}


defineExpose({
  state,
  uploadFile,
})

</script>
